import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import HoverText from './HoverText';

const Hero = () => {

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-32">
      {/* Video Background */}
      <div className="absolute inset-0 w-full h-full bg-gray-100">
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          className="w-full h-full object-cover"
          style={{
            filter: 'brightness(0.7) contrast(1.0)'
          }}
        >
          <source src="https://customer-assets.emergentagent.com/job_trees-charity/artifacts/l93hjysb_waldvideo.mp4" type="video/mp4" />
        </video>
      </div>

      {/* Dark Overlay for better text and logo readability */}
      <div className="absolute inset-0" style={{
        background: 'linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.2) 50%, rgba(0,0,0,0.3) 100%)'
      }} />

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 text-center mt-16">
        <div className="max-w-4xl mx-auto">
          <HoverText
            className="drop-shadow-2xl"
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 'clamp(32px, 6vw, 72px)',
              fontWeight: 700,
              lineHeight: 1.1,
              textAlign: 'center',
              marginBottom: '24px',
              textShadow: '2px 2px 12px rgba(0,0,0,0.8)',
              color: '#FFFFFF'
            }}
          >
            Wir schützen Wälder
          </HoverText>

          <HoverText
            className="mb-8 md:mb-12 drop-shadow-lg"
            style={{
              fontSize: 'clamp(18px, 3vw, 24px)',
              fontWeight: 400,
              lineHeight: 1.6,
              textShadow: '2px 2px 8px rgba(0,0,0,0.8)',
              color: '#FFFFFF',
              textAlign: 'center'
            }}
          >
            Gemeinsam schützen wir Wälder und ihre Bewohner. Jeder Baum zählt. Jedes Tier braucht ein Zuhause.
          </HoverText>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              size="lg"
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-[#FF1B8D] to-[#E01679] hover:from-[#E01679] hover:to-[#C01568] text-white px-8 py-6 rounded-full text-lg font-bold shadow-2xl hover:shadow-[0_0_40px_rgba(255,27,141,0.5)] transition-all duration-300 transform hover:scale-105"
            >
              Jetzt kontaktieren
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>

            <Button
              size="lg"
              variant="outline"
              onClick={() => scrollToSection('mission')}
              className="bg-white/90 backdrop-blur-sm border-2 border-gray-800 text-gray-800 hover:bg-gray-800 hover:text-white px-8 py-6 rounded-full text-lg font-bold shadow-xl transition-all duration-300"
            >
              Mehr erfahren
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;